import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router';
import { ROUTES } from '../../../../../constants/RouteNameMapping';
import { IListDataModel, ListType } from '../../../../../data-models/list.data-model';
import { activeCompanyListIdStateJ, listsStateJ } from '../../../../../services/state/ListsStateJ';

export function useSyncListsFromParams() {
  const companyLists = useAtomValue(listsStateJ);

  const setActiveListId = useSetAtom(activeCompanyListIdStateJ);
  const navigate = useNavigate();
  const { listId } = useParams();

  const mappedCompanyLists = useMemo(() => {
    if (!companyLists?.length) {
      return null;
    }
    const result: Record<ListType, IListDataModel[]> = {
      [ListType.DISCOVERY]: [],
      [ListType.MANAGEMENT]: [],
      [ListType.CUSTOM]: [],
      [ListType.ARCHIVE]: [],
    };

    const today = new Date();

    companyLists.forEach((l) => {
      if (l.archiveDate) {
        // Check to see if 30 days has passed since archiving
        const diff = new Date(l.archiveDate).getTime() - today.getTime();
        const numOfDays = diff / (1000 * 3600 * 24);

        if (numOfDays < 30 && numOfDays > 0) {
          result[ListType.ARCHIVE].push(l);
        }
      } else {
        result[l.type].push(l);
      }
    });
    return result;
  }, [companyLists]);

  useEffect(() => {
    const ListIdNumeric = Number(listId);

    if (Number.isNaN(ListIdNumeric)) {
      const preselectedList = mappedCompanyLists?.[ListType.DISCOVERY]?.[0];
      if (preselectedList) {
        navigate(`/${ROUTES.COMPANIES}/${ROUTES.LISTS}/${preselectedList?.id}`, { replace: true });
      }
    } else {
      setActiveListId(ListIdNumeric);
    }
  }, [companyLists, listId, mappedCompanyLists, navigate, setActiveListId]);
}
